import { apiIntegrations } from "@/api/integrations/integration.api.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const emailsKeys = createQueryKeys("emailsIntegrations", {
  integrations: null,
});

export const useEmailIntegrations = () => {
  return useQuery({
    ...emailsKeys.integrations,
    queryFn: async () => {
      const result = await apiIntegrations.getInstalled();

      if (result.error) throw new ApiErrorException(result.error);

      return result.data;
    },
    staleTime: 60 * 1000,
  });
};

export const useEmailDisconnect = () => {
  const queryClient = useQueryClient();
  const { onError } = useErrorHandle();

  return useMutation({
    mutationFn: async (id: number) => {
      const result = await apiIntegrations.uninstall(id);

      if (result.error || !result.data) throw new ApiErrorException(result.error);

      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: emailsKeys.integrations.queryKey,
      });
    },
    onError: (error: Error) => {
      onError(error);
    },
  });
};
